import axios from "axios";
import { API_BASE_URI } from "../../../redux/ApiCall";
import { authHeader } from "../../../utilities/utilities";

export const AddEmployeeApplication = (data: any) => {
  return axios.post(`${API_BASE_URI}/application`, data, authHeader());
};
